import React from 'react'
import Paper from '@mui/material/Paper';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination } from '@mui/material';


const SheetTable = ({ page, rowsPerPage, handleEditRow, sheetMappingData, handleChangePage, handleChangeRowsPerPage}) => {

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer className='TableVirtuoso' sx={{ maxHeight: "100vh" }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {sheetMappingData?.columns?.map((column) => (
                                <TableCell
                                    key={column.id}
                                    //align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sheetMappingData?.data?.length > 0 ? sheetMappingData?.data.map((row,i) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                                    {sheetMappingData?.columns?.map((column) => {
                                        const value = row[column.id];
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {column?.format && typeof value === 'number'
                                                    ? column.format(value) 
                                                    : column.id === 'actions' ? 
                                                    <>  
                                                        <IconButton 
                                                            color="inherit" 
                                                            title="Edit Sheet Data"
                                                            onClick={()=> handleEditRow(row)}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                    </>
                                                    : value 
                                                }
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        }) : <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            {sheetMappingData?.total > 0  ? 
                <TablePagination
                    rowsPerPageOptions={[100, 200, 500,{label:'ALL',value: -1}]}
                    component="div"
                    count={sheetMappingData?.total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage} 
                   // labelDisplayedRows={({from,to,count}) => console.log('to',to)}
                />
                : <></>
            }
        </Paper> 
    )
}

export default SheetTable